import React, { useState } from 'react';
import '../styles/footer.css';
import { useNavigate } from 'react-router-dom';

import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn
} from 'react-icons/fa';

import { ChevronRight } from 'lucide-react';

function Footer() {
  const navigate = useNavigate();
  const [menuActive, setMenuActive] = useState(false);

  const careerClick = () => {
    navigate('/jobs');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const aboutClick = () => {
    navigate('/about');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const servicesClick = () => {
    navigate('/services');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const contactClick = () => {
    navigate('/contact');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-divider" />

        <div className="footer-main">
          {/* Company Description Section */}
          <div className="footer-logo">
          <h2>VSK Global Infotech</h2>
            <p className="footer-description">
              Europe-based IT consulting and recruitment company helping organizations
              transform and grow through cutting-edge technology and top-tier talent.
            </p>
            <div className="subscribe-box">
              <input type="text" placeholder="Subscribe with us" />
              <button>&#9993;</button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li onClick={aboutClick}>
                <a href="#"><ChevronRight size={16} /> About</a>
              </li>
              <li onClick={servicesClick}>
                <a href="#"><ChevronRight size={16} /> Service</a>
              </li>
              <li onClick={careerClick}>
                <a href="#"><ChevronRight size={16} /> Career</a>
              </li>
              <li onClick={contactClick}>
                <a href="#"><ChevronRight size={16} /> Contact</a>
              </li>
            </ul>
          </div>

          {/* Useful Links */}
          <div className="footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <a href="#"><ChevronRight size={16} /> Privacy Policy</a>
              </li>
              <li>
                <a href="#"><ChevronRight size={16} /> Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 VSK Global Infotech</p>
        <div className="footer-socials">
          <a href="#"><FaFacebookF /></a>
          <a href="#"><FaTwitter /></a>
          <a href="#"><FaYoutube /></a>
          <a href="#"><FaLinkedinIn /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
